// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thankyou-page[data-v-9e0da12e]{-webkit-animation-name:fade-in;animation-name:fade-in;-webkit-animation-duration:2s;animation-duration:2s;text-align:center}.return-button[data-v-9e0da12e]{padding:10px;padding-left:20px;padding-right:20px;border:0;background-color:#0092c8;color:#fff;font-size:14px;font-weight:700;text-transform:uppercase}.return-button[data-v-9e0da12e]:hover{opacity:.8}", ""]);
// Exports
module.exports = exports;
